export class ArtifactRegistry {
  constructor() {
    this.renderers = new Map();
    this.anims = new Map();
  }

  registerRenderer(id, renderer) {
    if (!id || typeof renderer?.draw !== 'function') {
      throw new Error(`Invalid renderer registration for id: ${id}`);
    }
    this.renderers.set(id, renderer);
  }

  registerAnim(id, anim) {
    if (!id || typeof anim?.eval !== 'function') {
      throw new Error(`Invalid animation registration for id: ${id}`);
    }
    this.anims.set(id, anim);
  }

  getRenderer(id) {
    return this.renderers.get(id);
  }

  getAnim(id) {
    return this.anims.get(id);
  }
}
